/* Maxwell Property Services interactive navigation and text-estimate workflow.
   No network requests; messages are never transmitted until the visitor sends an SMS. */
(function(){
  'use strict';
  function setupMenu(){
    var toggle=document.querySelector('[data-menu-toggle]');
    var nav=document.getElementById('MobileNav');
    if(!toggle || !nav) return;
    var close=function(){nav.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Open navigation');document.body.classList.remove('menu-open');};
    toggle.addEventListener('click',function(){
      var open=nav.hidden;
      nav.hidden=!open;
      toggle.setAttribute('aria-expanded',String(open));
      toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');
      document.body.classList.toggle('menu-open',open);
    });
    nav.addEventListener('click',function(e){if(e.target.closest('a'))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape' && !nav.hidden){close();toggle.focus();}});
    document.addEventListener('click',function(e){if(!nav.hidden && !e.target.closest('[data-header]'))close();});
    window.addEventListener('resize',function(){if(window.innerWidth>1150 && !nav.hidden)close();});
  }
  function setupQuote(form){
    var one=form.querySelector('[data-step="1"]');
    var two=form.querySelector('[data-step="2"]');
    var result=form.querySelector('[data-preview]');
    var status=form.closest('.quote-panel').querySelector('[data-step-label]');
    var error=form.querySelector('[data-form-error]');
    var message=form.querySelector('[data-message]');
    var openSms=form.querySelector('[data-open-sms]');
    var phone=form.getAttribute('data-phone')||'+16054082180';
    var serviceOptions=Array.from(form.querySelectorAll('[name="service"]'));
    var q=new URLSearchParams(window.location.search).get('service');
    if(q){
      var match=serviceOptions.find(function(radio){return radio.value.trim().toLowerCase()===q.trim().toLowerCase();});
      if(match){match.checked=true;}
      else{
        var other=serviceOptions.find(function(r){return r.value.toLowerCase().indexOf('multiple services')===0;});
        if(other){other.checked=true;}
      }
    }
    function field(name){return form.elements.namedItem(name);}
    function choice(){return form.querySelector('[name="service"]:checked');}
    function step(index){
      one.hidden=(index!==1);two.hidden=(index!==2);result.hidden=true;
      error.hidden=true;
      if(status)status.textContent='Step '+index+' of 2';
    }
    function fail(input,text){
      error.hidden=false;
      error.textContent=text||'Please complete the required fields.';
      if(input && input.focus)input.focus();
      return false;
    }
    function validateFirst(){
      if(!choice())return fail(serviceOptions[0],'Please select the service you need.');
      var name=field('name');
      if(!name.value.trim())return fail(name,'Please enter your name.');
      var address=field('address');
      if(!address.value.trim() || !address.checkValidity())return fail(address,'Please enter the full service address (street, city, state and ZIP).');
      error.hidden=true;
      return true;
    }
    function validateSecond(){
      var details=field('details');
      if(!details.value.trim())return fail(details,'Please describe the work you need done.');
      error.hidden=true;
      return true;
    }
    function line(key,value){return key+': '+value;}
    form.querySelector('[data-next]').addEventListener('click',function(){
      if(validateFirst()){
        step(2);two.scrollIntoView({behavior:'smooth',block:'nearest'});
        two.querySelector('textarea').focus({preventScroll:true});
      }
    });
    form.querySelector('[data-back]').addEventListener('click',function(){
      step(1);one.scrollIntoView({behavior:'smooth',block:'nearest'});
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!validateFirst()){
        one.hidden=false;two.hidden=true;result.hidden=true;
        if(status)status.textContent='Step 1 of 2';
        return;
      }
      if(!validateSecond())return;
      var sms=[
        'Hi Maxwell Property Services! I would like a free estimate.',
        line('Name',field('name').value.trim()),
        line('Property address',field('address').value.trim()),
        line('Service',choice().value),
        line('Project details',field('details').value.trim()),
        line('Preferred timing',field('timing').value),
        line('Debris haul-away',field('haul').value)
      ];
      var callback=field('callback').value.trim();
      if(callback)sms.push(line('My phone',callback));
      if(field('photo').checked)sms.push('I can attach photos to this text.');
      sms.push('Please let me know the next steps. Thank you!');
      var smsBody=sms.join('\n');
      message.value=smsBody;
      // iOS Messages accepts &body when a recipient is present; other SMS clients use ?body.
      var ios=/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1);
      openSms.href='sms:'+phone+(ios?'&body=':'?body=')+encodeURIComponent(smsBody);
      one.hidden=true;two.hidden=true;result.hidden=false;error.hidden=true;
      if(status)status.textContent='Ready to send';
      result.scrollIntoView({behavior:'smooth',block:'nearest'});
      result.focus({preventScroll:true});
    });
    form.querySelector('[data-copy]').addEventListener('click',function(){
      var copyStatus=form.querySelector('[data-copy-status]');
      var success=function(){copyStatus.textContent='Copied. Paste into a text to '+phone+'.';};
      if(navigator.clipboard && window.isSecureContext){
        navigator.clipboard.writeText(message.value).then(success,function(){
          message.focus();message.select();copyStatus.textContent='Select and copy the message above.';
        });
      }else{
        message.focus();message.select();
        try{if(document.execCommand('copy'))success();else copyStatus.textContent='Select and copy the message above.';}
        catch(e){copyStatus.textContent='Select and copy the message above.';}
      }
    });
    form.querySelector('[data-edit]').addEventListener('click',function(){
      step(2);two.scrollIntoView({behavior:'smooth',block:'nearest'});
    });
  }
  function setupMobileCta(){
    var form=document.querySelector('.quote-panel');
    if(!form || !('IntersectionObserver' in window))return;
    var observer=new IntersectionObserver(function(entries){
      document.body.classList.toggle('quote-in-view',entries.some(function(entry){return entry.isIntersecting;}));
    },{threshold:0.12});
    observer.observe(form);
  }
  function init(){setupMenu();document.querySelectorAll('[data-quote-form]').forEach(setupQuote);setupMobileCta();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
